const MARKDOWN_FENCED_CODE_BLOCK_REGEX = /```[\s\S]*?```/g;
const MARKDOWN_INLINE_CODE_REGEX = /`[^`\n]*`/g;
const MARKDOWN_BLUE_LINK_REGEX = /(?<!!)\[([^\]]+)\]\(([^)]+)\)/g;

export const getBlueLinkCount = (markdown: string): number =>
	(
		markdown
			.replace(MARKDOWN_FENCED_CODE_BLOCK_REGEX, '')
			.replace(MARKDOWN_INLINE_CODE_REGEX, '')
			.match(MARKDOWN_BLUE_LINK_REGEX) ?? []
	).length;
